import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../react-commons/query/QueryBaseComponent';
import {
    ContentMutationResourceSchema,
    defaultContentResource,
    useContentActions,
} from '../../../resource/resources/artifacts/content/contentResource';
import { Form_EditableViewWrapper } from '../../reusable-components/form-components/Form_EditableViewWrapper';
import { selectReadOnly } from '../../util/useSelectorFunctions';
import { ContentContent } from './ContentContent';

export const ContentView = ({ id }: { id: string | undefined }) => {
    const readOnly = useSelector(selectReadOnly);

    const contentActions = useContentActions();
    const contentQuery = contentActions.useGetResource(id);
    const updateContent = contentActions.useUpdateResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ContentMutationResourceSchema,
        defaultValues: defaultContentResource,
        submitHandler: async (data) => {
            await updateContent.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: contentQuery.data,
    });

    return (
        <QueryBaseComponent name="Content" query={contentQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ContentContent
                    form={form}
                    formNames={formNames}
                    id={id}
                    readOnly={readOnly}
                    versionId={contentQuery.data?.versionedIn}
                />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
